import { render, staticRenderFns } from "./Snack_series.vue?vue&type=template&id=360985af&scoped=true"
import script from "./Snack_series.vue?vue&type=script&lang=js"
export * from "./Snack_series.vue?vue&type=script&lang=js"
import style0 from "./Snack_series.vue?vue&type=style&index=0&id=360985af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360985af",
  null
  
)

export default component.exports